import React from "react";
import { IconProps } from "../../utils/global-types/global-types";

const HideIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-[18px] h-[18px]"}
      {...rest}
    >
      <g fill="currentColor" clipPath="url(#clip0_8184_119285)">
        <path d="M14.756 14.756 3.243 3.244l-.002-.003a.669.669 0 0 0-.942.95l1.008 1.007a11.7 11.7 0 0 0-3.1 3.13 1.2 1.2 0 0 0 0 1.348c2.108 3.12 5.45 4.949 8.793 4.926a9.6 9.6 0 0 0 3.18-.533l1.632 1.632a.668.668 0 0 0 .947-.942zM9 12.788a3.79 3.79 0 0 1-3.451-5.35L6.602 8.49a2.452 2.452 0 0 0 2.907 2.907l1.053 1.053A3.8 3.8 0 0 1 9 12.788M17.793 8.325C15.685 5.203 12.343 3.375 9 3.398a9.6 9.6 0 0 0-3.18.533l1.617 1.617a3.79 3.79 0 0 1 5.014 5.014l2.241 2.241a11.7 11.7 0 0 0 3.101-3.129 1.2 1.2 0 0 0 0-1.349"></path>
        <path d="M9 6.548q-.257 0-.51.054L11.4 9.509A2.453 2.453 0 0 0 9 6.55"></path>
      </g>
      <defs>
        <clipPath id="clip0_8184_119285">
          <path fill="#fff" d="M0 0h18v18H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default HideIcon;
